import React from "react";

import deleticon from "assets/images/deleticon.svg";
import { Button } from "components/ui/Button";

import s from "./DeleteModal.module.css";
export const DeleteModal = ({ deleteService, context, itemName, modalId }) => {
  const modalText =
    context === "task"
      ? "Are you sure you want to delete this task?"
      : context === "stopMedication"
      ? "Are you sure you want to stop this medication?"
      : context === "smsTemplate"
      ? "Are you sure you want to delete this SMS template?"
      : context === "document"
      ? "Are you sure you want to delete this Document?"
      : context === "service"
      ? "Are you sure you want to delete this service?"
      : context === "note"
      ? "Are you sure you want to delete this note?"
      : context === "user"
      ? `Are you sure you want to delete this ${itemName}?`
      : context === "vaccine"
      ? "Are you sure you want to delete this vaccine?"
      : "Are you sure you want to delete?";

  return (
    <>
      <div className="modal warningmodal_box" id={modalId || "myModal"}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className={`${s.btnClose} btn-close`}
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body">
              <div className={s.worningimg}>
                <img src={deleticon} alt="" />
              </div>
              <div className={s.deletext}>
                <h5>{modalText}</h5>
              </div>
            </div>

            <div className={s.modalFooter}>
              <Button
                variant="outline"
                                data-bs-dismiss="modal"
                style={{ minWidth: "180px", flexGrow: 1 }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                                type="submit"
                onClick={deleteService}
                data-bs-dismiss="modal"
                style={{ minWidth: "180px", flexGrow: 1 }}
              >
                Yes
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
